'use strict';

import { interfaceName } from './settings';

import { AjaxForm } from './modules/ajax-form';
import { Goal } from './modules/goal';
import { Responsive } from './modules/responsive';
import { Sliders } from './modules/sliders';
import { showMap } from './modules/map';
import { More,Branch,Catalog,Tabs, Activities } from './modules/more';
import { header } from './modules/header';
import { GetProd } from './modules/ajax-filter';
import { GetProject } from './modules/ajax-projects';
import { Product } from './modules/product';
import { Gallery } from './modules/gallery';
import { Select } from './modules/selectors';
import { Menu } from './modules/menu';
import { LandSliders } from './modules/landing-sliders';
import { SmoothScroll } from './modules/scroll';
import { ajaxVisSlider } from './modules/ajax-vis-slider'
 
let Proj = function() {};

Proj.prototype.interfaceName = interfaceName;

Proj.prototype.AjaxForm = AjaxForm;
Proj.prototype.Goal = Goal;
Proj.prototype.Responsive = Responsive;
Proj.prototype.Sliders = Sliders;
Proj.prototype.showMap = showMap;
Proj.prototype.More = More;
Proj.prototype.header = header;
Proj.prototype.Branch = Branch;
Proj.prototype.Catalog = Catalog;
Proj.prototype.GetProd = GetProd;
Proj.prototype.Product = Product;
Proj.prototype.Gallery = Gallery;
Proj.prototype.Select = Select;
Proj.prototype.GetProject = GetProject;
Proj.prototype.Menu = Menu;
Proj.prototype.Tabs = Tabs;
Proj.prototype.LandSliders = LandSliders;
Proj.prototype.SmoothScroll = SmoothScroll;
Proj.prototype.Activities = Activities;
Proj.prototype.ajaxVisSlider = ajaxVisSlider;

global.Proj = Proj;

export { Proj };
